import script from "./infoPoup.vue?vue&type=script&setup=true&lang=ts"
export * from "./infoPoup.vue?vue&type=script&setup=true&lang=ts"

import "./infoPoup.vue?vue&type=style&index=0&id=872fa40a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-872fa40a"]])

export default __exports__